import { Box, Paragraph } from '@zillow/constellation-10';

import { getContactType } from '../../../../utils/listingClaimUtils';

import ContactMethodDetail from '../../../ListingClaim/ContactMethodDetail';

export type RemovableContactsListProps = {
  contactMethods: Array<{ value: string; isVerified: boolean; canBeRemoved: boolean }>;
  incrementStep: () => void;
  onContactMethodSelection: (contactMethod: { type: 'email' | 'phone'; value: string }) => void;
};

const RemovableContactsList = ({
  contactMethods,
  incrementStep,
  onContactMethodSelection,
}: RemovableContactsListProps) => {
  const handleDelete = ({ value }: { value: string }) => {
    onContactMethodSelection({ value, type: getContactType({ value }) });
    incrementStep();
  };

  return (
    <div data-testid="RemovableContactsList">
      <Paragraph css={{ marginBottom: '400' }}>
        Removing an unverified contact method will also remove any listings associated with that contact
      </Paragraph>
      <Box>
        {contactMethods.map((contactMethod) => (
          <ContactMethodDetail
            key={`removable-contact-${contactMethod.value}`}
            data={contactMethod}
            onDelete={handleDelete}
            inManageContactModal={true}
          />
        ))}
      </Box>
    </div>
  );
};

export default RemovableContactsList;
